import { InputContainer } from "@/components/ui/forms/inputContainer"
import { cn } from "@/modules/lib/utils"
import { HUImageForm } from "@/modules/ui/components/huImageForm"
import { type SimpleFormik } from "@/typings/formik"
import { type BoxFormikType, type BoxInputKey } from "@modules/box/boxFormikType"
import { BoxPhotosForm } from "@modules/box/components/boxUpdateForm/boxPhotosForm"
import { word } from "@modules/core/utils/i18n"
import { getFormErrorMessage } from "@modules/formik/formikUtils"

type BoxSecondaryInfoFormProps = {
  formik: SimpleFormik<BoxFormikType, BoxInputKey> & {
    setFieldTouched: (field: string, touched?: boolean, shouldValidate?: boolean) => void
  }
  setIsImageUploading: (isImageUploading: boolean) => void
} & React.ComponentProps<"div">

export function BoxSecondaryInfoForm({ formik, setIsImageUploading, className, ...props }: BoxSecondaryInfoFormProps) {
  const acceptedTypes = "image/jpeg, image/png, image/webp"

  return (
    <div
      className={cn("mb-0 flex w-full flex-col gap-4 rounded-2xl bg-neutral-50 p-8 xl:w-4/12", className)}
      {...props}
    >
      {/* Logo input */}
      <InputContainer error={getFormErrorMessage("logo", formik)} label={word("box.form.logo.label")} isRequiredInput>
        <HUImageForm
          type="logo"
          setImage={(e) => {
            formik.setFieldValue("logo", e)
          }}
          image={formik.values.logo}
          size="220px"
          acceptedTypes={acceptedTypes}
          resizer={false}
          hideButton={true}
          placeHolder={{
            message: word("program.form.uploadImage.text1"),
            style: { paddingLeft: "2.28rem", paddingRight: "2.28rem" },
          }}
        />
      </InputContainer>

      {/* Cover input */}
      <InputContainer error={getFormErrorMessage("cover", formik)} label={word("box.form.cover.label")} isRequiredInput>
        <HUImageForm
          type="cover"
          setImage={(e) => {
            formik.setFieldValue("cover", e)
          }}
          image={formik.values.cover}
          size="220px"
          acceptedTypes={acceptedTypes}
          resizer={false}
          hideButton={true}
          placeHolder={{
            message: word("program.form.uploadImage.text1"),
            style: { paddingLeft: "1.75rem", paddingRight: "1.75rem" },
          }}
        />
      </InputContainer>

      {/* Box photos carousel input */}
      <BoxPhotosForm
        boxPhotos={formik.getFieldProps("boxPhotos").value}
        setBoxPhotos={(photos) => void formik.setFieldValue("boxPhotos", photos)}
        setIsImageUploading={setIsImageUploading}
      />
    </div>
  )
}
